// import { assetApi } from 'api/assetApi';
import { weatherApi } from 'api/weatherApi';
import { inverterInfo } from 'models';
import * as React from 'react';
import EnvironmentInfo from '../EnvironmentInfo/EnvironmentInfo';
import NotEnvironmentInfo from '../NotEnvironmentInfo/NotEnvironmentInfo';

export interface EnvironmentProps {
  itemSelected: string | null;
}

export default function Environment(props: EnvironmentProps) {
  const { itemSelected } = props;
  const [environment, setEnvironment] = React.useState<inverterInfo | undefined>();

  React.useEffect(() => {
    if (itemSelected) {
      (async () => {
        const response: any = await weatherApi.fetchWeatherStation(itemSelected);
        setEnvironment(response);
      })();
    }
  }, [itemSelected]);
  // React.useEffect(() => {
  //   if (itemSelected) {
  //     (async () => {
  //       const response: any = await weatherApi.fetchWeatherStation(itemSelected);
  //       setEnvironment(response);
  //     })();
  //   }
  // }, []);

  return (
    <>
      {environment ? (
        <EnvironmentInfo environment={environment} setEnvironment={setEnvironment} />
      ) : (
        <NotEnvironmentInfo paramId={itemSelected} setEnvironment={setEnvironment} />
      )}
    </>
  );
}
